export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/40"></div>
      <div className="absolute top-20 right-0 w-[500px] h-[500px] bg-primary-200/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-10 left-[-100px] w-[400px] h-[400px] bg-accent-200/15 rounded-full blur-3xl"></div>

      <div className="relative w-full max-w-screen-2xl mx-auto px-4 md:px-6 pt-[72px]">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-100/80 text-accent-800 text-xs font-medium mb-5">
              <i className="ri-fire-line text-sm"></i>
              <span>每日更新 · 海量漫画 · 追更必备</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              番茄漫画
              <span className="block text-primary-600">追更漫画连载更新平台</span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-heading font-medium mb-5">
              最新话追漫提醒，免费全集完结韩漫日漫国漫，流畅下拉式阅读
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              番茄漫画专注漫画追更体验，聚合全网热门韩漫、日漫、国漫资源，覆盖热血、恋爱、奇幻、悬疑等全品类。
              每日同步更新最新话，提供追漫提醒、全集阅读、完结漫画一站式服务。下拉式滚动阅读让浏览更流畅，
              无需翻页即可沉浸追漫。当前热门连载《剑尊归来》《我独自升级》《全职高手》等持续更新中。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 mb-7">
              <div className="flex items-center gap-1.5">
                <span className="text-2xl font-heading font-bold text-primary-600">2000+</span>
                <span className="text-xs text-foreground-500">部漫画资源</span>
              </div>
              <div className="w-px h-5 bg-background-300"></div>
              <div className="flex items-center gap-1.5">
                <span className="text-2xl font-heading font-bold text-accent-600">日更</span>
                <span className="text-xs text-foreground-500">同步连载</span>
              </div>
              <div className="w-px h-5 bg-background-300"></div>
              <div className="flex items-center gap-1.5">
                <span className="text-2xl font-heading font-bold text-primary-600">全免费</span>
                <span className="text-xs text-foreground-500">无付费墙</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer no-underline text-sm"
              >
                <i className="ri-book-open-line text-lg"></i>
                开始追漫
              </a>
              <a
                href="#features"
                className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 text-foreground-700 font-medium rounded-full hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer no-underline text-sm"
              >
                <i className="ri-information-line text-lg"></i>
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[420px] aspect-[3/4] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20manga%20illustration%20wall%20featuring%20dynamic%20comic%20panels%20with%20action%20scenes%2C%20romance%2C%20fantasy%20characters%20in%20warm%20colors%2C%20Japanese%20and%20Korean%20manhwa%20art%20style%20collage%2C%20expressive%20character%20portraits%2C%20speed%20lines%2C%20dramatic%20lighting%2C%20clean%20cream%20background%2C%20editorial%20composition%2C%20high%20detail&width=840&height=1120&seq=hero-manga-visual-01&orientation=portrait"
                alt="番茄漫画 - 热门漫画主视觉合集"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent rounded-2xl"></div>
              <div className="absolute bottom-4 left-4 right-4 flex gap-2 flex-wrap">
                <span className="px-2.5 py-1 bg-background-50/90 backdrop-blur-sm rounded-full text-xs font-medium text-foreground-800 whitespace-nowrap">韩漫热榜</span>
                <span className="px-2.5 py-1 bg-background-50/90 backdrop-blur-sm rounded-full text-xs font-medium text-foreground-800 whitespace-nowrap">日漫新番</span>
                <span className="px-2.5 py-1 bg-background-50/90 backdrop-blur-sm rounded-full text-xs font-medium text-foreground-800 whitespace-nowrap">国漫崛起</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}